module.exports = __webpack_public_path__ + "static/media/team2.b83ce8b8.jpg";